import { render, staticRenderFns } from "./OpenFieldInput.vue?vue&type=template&id=604f9608&scoped=true"
import script from "./OpenFieldInput.vue?vue&type=script&lang=js"
export * from "./OpenFieldInput.vue?vue&type=script&lang=js"
import style0 from "./OpenFieldInput.vue?vue&type=style&index=0&id=604f9608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f9608",
  null
  
)

export default component.exports